import { useQuery } from '@tanstack/react-query';
import type { Dayjs } from 'dayjs';
import { http } from 'services/http';
import { TRANSIT_TIME_GET } from 'api/query-keys';
import type { TGetTransitTimeRes } from 'api/swagger';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface ITransitTimeFilter {
  date?: Dayjs[];
  fromWarehouseId?: number;
  toWarehouseId?: number;
}

interface IParams {
  filters: ITransitTimeFilter;
}

export const useGetTransitTime = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<ITransitTimeFilter>(qs, filters);

  return useQuery({
    queryKey: [TRANSIT_TIME_GET, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetTransitTimeRes>(`/v1/statistics/transit-time?${qs.toString()}`);
      return data;
    },
    enabled: Boolean(filters.fromWarehouseId && filters.toWarehouseId),
    retry: false,
    refetchOnWindowFocus: false,
  });
};
